<template>
  <vx-card class="mt-base mb-5" title="1. Push-Ups">
    <p class="mb-5">
      The push-up is one of the most challenging physical aspects of the selection process. Read
      through the details below for a breakdown of how to do one:
    </p>

    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
        <img
          src="@/assets/images/experiences/policing/info1.png"
          alt="Push ups. Goal: you will need to achieve five successive push ups on your toes. How: start by lying flat on the ground with your hands below your shoulders and your toes making contact with the floor. Then push up, keeping your back and arms straight. Then, continuing to keep your back straight, lower your torso until your arms are at a 90 degree angle from shoulder to elbow, with your body in a straight line. Repeat five times. Why: to measure your upper body strength. Tip: ensure you follow correct technique, focus on being able to control each push up and practise to be able to do more than the five reps required for the test."
          class="mx-auto img-responsive"
        />
      </div>
    </div>

    <p class="mb-5">
      If you can already do 5 push-ups with good form, well done! You can continue working hard and
      trying to increase the amount you can do. 5 full push-ups are the minimum requirement for
      Victoria Police, but other forces have a higher minimum required number of push-ups. Although
      there is a minimum of 5 push ups in this task, no police force has a maximum! So, the more you
      can do, the stronger you’ll become. Keep practising!
    </p>
    <p class="mb-5">
      However, for many of us, going straight into doing 5 full push-ups will take a little practice
      and some training of the muscles before we can reach the required number.
    </p>
    <p class="mb-5">
      To help you reach the target number, watch the video below to learn how to do a progression of
      exercises leading into doing the full push-up.
    </p>
    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5 text-center">
        <responsive-iframe-youtube :src="videos[1]" :posterimg="videoTrigger1" />
      </div>
    </div>

    <p class="my-5" style="font-size: 110%">
      <strong><u>Push-Ups Progressive Training Programme</u></strong>
    </p>
    <p class="mb-5">
      Follow the programme as laid out below to record your progression of the number of push-ups
      you can do across the course of your virtual job experience. There were 3 types of push-ups
      discussed in the training video from Victoria Police. They were:
    </p>
    <ul class="default-list">
      <li>Incline Push-Ups</li>
      <li>Hand Release Push-Ups</li>
      <li>Full Push-ups</li>
    </ul>
    <p class="mb-5">
      If you can’t yet do a full push-up, use the following training programme to work up to it.
      Start with Stage 1: Incline Push-Ups. Do as many of these as you can each day for 6 days. Then
      take a day to rest and move to Stage 2: Hand Release Push-Ups.
    </p>
    <p class="mb-5">
      If you can’t yet do a hand release push-up, stay at Stage 1 until you build up enough
      strength. Then, move to the next stage.
    </p>
    <p class="mb-5">
      Once you’re on Stage 2, do as many of these as you can for 6 days, then take a day to rest
      before starting Stage 3: Full Push-Ups.
    </p>
    <p class="mb-5">
      If you can’t yet do a full push-up, stay at Stage 2 until you build up enough strength. Then,
      move to the next stage.
    </p>
    <p class="mb-5">
      Once you’re on Stage 3, the skies the limit! Practice doing push-ups every day and you’ll
      become super strong over time. No matter what the required minimum number of push-ups is for
      the police force you’re interested in joining, you’ll have no problem!
    </p>
    <p class="mb-5">Remember to record your results in the Physical Training Record Sheet.</p>
    <p class="mb-5">
      <strong>NOTE:</strong> The Australian Federal Police push-up requirements are:
    </p>
    <p class="mb-5">
      Male applicants: 15 push-ups for entry-level and 30 push-ups to graduate from training
      college.
    </p>
    <p class="mb-5">
      Female applicants: 8 push-ups for entry-level and 15 push-ups to graduate from training
      college.
    </p>
    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5 text-center">
        <responsive-iframe-youtube :src="videos[2]" :posterimg="videoTrigger2" />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-checkbox v-model="confirmed" name="confirmed"
          >I have read all the information on this page
        </vs-checkbox>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <button class="btn btn-secondary btn-size-medium mb-1" @click="$router.back()">Back</button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import store from '@/store/store';

export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/policing/push_ups.jpg'),
      videoTrigger2: require('@/assets/images/experiences/policing/afp_push_ups.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/N3B4vPcCrDE',
        2: 'https://www.youtube.com/embed/lOGJsHnnKyw',
      },
      confirmed: false,
    };
  },
  methods: {
    showVideoPopup(id) {
      store.dispatch(
        'popup/showVideoPopup',
        $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL + '/content/policing/' + this.videos[id],
      );
    },
  },
};
</script>
